<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    document.title = this.$t('lang.认证经销商服务平台')
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue